interface Msg {
    type: string,
    data: any
}

import { GlobalObject } from '../utils/GlobalObject';
import { FacilityInfo } from '../displayObject/UI/FacilityInfo';

export class Boardcaster {
    private bc: BroadcastChannel;
    private static instance: Boardcaster;
    private stage?: any;
    //public VIEW_ANGLE_CHANGED: string = "viewAngleChanged"; //视角切换 data:1,2,3
    //public CAM_CHANGE: string = "camChanged"; // 显示/隐藏监控的模型
    public WORKSHOP_CHANGE: string = "workshopChanged"; // 进入车间或园区
    public OPEN_EQUIPMENT: string = "openEquipment"; // 查看设备详情
    public OPEN_CAM: string = "openCam"; // 查看摄像头监控
    public OPEN_FACILITY: string = "openFancility"; // 抓取设备数据

    public GET_FACILITY_BY_ID: string = "getFacilityById"; // 悬浮面板获取设备数据


    constructor() {
        this.bc = new BroadcastChannel('hql23');
        this.ListenMessage(); // 接收同源2D页面传参
    }
    public static getInstance(): Boardcaster {
        if (!Boardcaster.instance) {
            Boardcaster.instance = new Boardcaster();
        }
        return Boardcaster.instance;
    }
    private ListenMessage() {
        this.bc.onmessage = (e) => {
            console.log(e, e.data);
            const msg: Msg = e.data;
            if (!this.stage) {
                console.log("没有为BC设置stage.")
                return;
            }
            switch (msg.type) {
                case 'viewAngleChanged':
                    this.stage.onViewAngleChanged(msg.data);
                    break;
                case 'camChanged':
                    this.stage.onCamChanged(msg.data);
                    break;
                case 'workshopChanged':
                    this.stage.onWorkshopChanged(msg.data);
                    break;
                case 'fancilityStatus':
                    // { "type":"fancilityStatus", "data":{"010_43":"维修中", "010_44":"正常", "010_45":"故障" } }
                    GlobalObject.getInstance().setFancilityData(msg.data);
                    this.stage.createFancility(); // 更新设备状态信息
                    break;
                case 'getFacilityByIdBack':
                    // {"type": "getFacilityByIdBack", "data": { "设备编号": "026-038","设备型号": "TX6111C","设备规格": "D110","设备名称": "数显卧式镗床","进厂日期": "2006-08-01","制造厂家": "昆明机床股份有限公司" } }
                    FacilityInfo.getInstance().setText(msg.data); // 拿到单个设备的详细信息，显示在悬浮面板
                    break;
                case 'backFactoryFromEquipment':
                    if (this.stage.back) {
                        this.stage.back();
                    }
                    break;
                default:
                    break;
            }
        }
        this.bc.onmessageerror = (e) => {
            console.log(e);
        };
        console.log(this.bc);
    }
    public send(msg: { type: string, data: any }) {
        console.log("bc send message:", msg);
        this.bc.postMessage({ msg });
    }
    public setStage(stage: any) {
        this.stage = stage;
    }
    private close() {
        this.bc.close();
    }
}